<template>
    <div class="nav-main">
        <div class="nav-item">
            <div v-if="loggedIn">
                <ion-icon @click="openMenu" v-if="this.$route.name == 'menu_categories'" name="menu-outline"></ion-icon>
                <ion-icon @click="goBack" v-else name="arrow-back"></ion-icon>
            </div>
            <div v-else>
                <ion-icon @click="goToSplash" v-if="this.$route.name == 'menu_categories' && !loggedIn" name="person-outline"></ion-icon>
                <ion-icon @click="goBack" v-else name="arrow-back"></ion-icon>

            </div>
        </div>
        <div class="nav-item">
            <router-link :to="{path: '/'}"><ion-icon name="home"></ion-icon></router-link>
        </div>
        <div class="nav-item">
            <router-link class="basket" :to="{name: 'cart'}">
                <div class="d-flex justify-content-center">
                    <span class="counter">{{ getTotalInCart }}</span><ion-icon name="basket"></ion-icon>
                </div>
                <span style="font-size: 10px" class="text-center small d-block">View order</span>
            </router-link>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: "TopNav",

        data(){
            return {
                loggedIn: localStorage.getItem("token"),
            }
        },

        methods: {
            goBack() {
                this.$router.go(-1);
            },

            openMenu(e) {
                this.$emit('openMenu', e)
            },
            goToSplash(){
                this.$router.push({name: 'splash'})
            }
        },

        computed: {
            ...mapGetters([
                'getTotalInCart',
            ]),
        }
    }
</script>

<style scoped>

</style>